import { HashRouter, Routes, Route } from 'react-router-dom';
import ProtectedLayout from './ProtectedLayout';
import PublicRoute from './PublicRoutes';
import { NotFounded } from '@/pages/NotFounded';
import { Home } from '@/pages/home/Home';
import SignUp from '@/pages/signUp/SignUpStepper';
import Schedule from '@/pages/scheduling/SchedulingStepper';
import { Login } from '@/pages/login/Login';
import { ForgotPassword } from '@/pages/forgotPassword/ForgotPassword';
import { CreateNewPassword } from '@/pages/createNewPassword/CreateNewPassword';
import { AppointmentDetails } from '@/pages/home/appointmentDetails/AppointmentDetails';
import { Appointments } from '@/pages/appointmentList/Appointments';
import { PrivacyPolicy } from '@/pages/privacyPolicy/PrivacyPolicy';
import { DataCollection } from '@/pages/privacyPolicy/dataCollection/DataCollection';
import { DataUse } from '@/pages/privacyPolicy/dataUse/DataUse';
import { DataSecurity } from '@/pages/privacyPolicy/dataSecurity/DataSecurity';
import { TermsOfUse } from '@/pages/termsOfUse/TermsOfUse';
import { Telemedicine } from '@/pages/termsOfUse/telemedicine/Telemedicine';
import { CancellationPolicy } from '@/pages/termsOfUse/cancellationPolicy/CancellationPolicy';
import { CodeWrapper } from '@/pages/codeWrapper/CodeWrapper';
// import { QRCode } from '@/pages/qrCode/QRCode';
import { DownloadApp } from '@/pages/qrCode/DownloadApp';
import { DeleteAccount } from '@/pages/deleteAccount/DeleteAccount';

const RouteLogger = () => {
  return null;
};

const AppRoutes = () => {
  return (
    <HashRouter>
      <RouteLogger />
      <Routes>
        {/* Rotas públicas */}
        <Route
          path="/"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/resend_code"
          element={
            <PublicRoute>
              <CodeWrapper />
            </PublicRoute>
          }
        />
        <Route
          path="/create-new-password"
          element={
            <PublicRoute>
              <CreateNewPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/signup"
          element={
            <PublicRoute>
              <SignUp />
            </PublicRoute>
          }
        />
        <Route
          path="/delete-account"
          element={
            <PublicRoute>
              <DeleteAccount />
            </PublicRoute>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <PublicRoute>
              <PrivacyPolicy />
            </PublicRoute>
          }
        />
        <Route
          path="/data-collection"
          element={
            <PublicRoute>
              <DataCollection />
            </PublicRoute>
          }
        />
        <Route
          path="/data-use"
          element={
            <PublicRoute>
              <DataUse />
            </PublicRoute>
          }
        />
        <Route
          path="/data-security"
          element={
            <PublicRoute>
              <DataSecurity />
            </PublicRoute>
          }
        />
        <Route
          path="/terms-of-use"
          element={
            <PublicRoute>
              <TermsOfUse />
            </PublicRoute>
          }
        />
        <Route
          path="/telemedicine"
          element={
            <PublicRoute>
              <Telemedicine />
            </PublicRoute>
          }
        />
        <Route
          path="/cancellation_policy"
          element={
            <PublicRoute>
              <CancellationPolicy />
            </PublicRoute>
          }
        />

        <Route
          path="/download_app"
          element={
            <PublicRoute noRedirect>
              <DownloadApp />
            </PublicRoute>
          }
        />

        {/* Rotas protegidas */}
        <Route element={<ProtectedLayout />}>
          <Route path="/home" element={<Home />} />
          <Route
            path="/appointment/:appointmentId"
            element={<AppointmentDetails />}
          />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/rescheduling/:appointmentId" element={<Schedule />} />
          <Route path="/appointments" element={<Appointments />} />
          {/* <Route path="/qr_code" element={<QRCode />} /> */}
        </Route>

        {/* Fallback para rotas inválidas */}
        <Route path="*" element={<NotFounded />} />
      </Routes>
    </HashRouter>
  );
};

export default AppRoutes;
